import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DraggableModalDialog } from './DraggableModalDialog';

function AddCommentDialog({ showDialog, closeDialog, businessUnitDetails, onSave }) {

    const { t } = useTranslation();

    const [comment, setComment] = useState("");
    const [commentReasonCodeId, setCommentReasonCodeId] = useState();
    const [validated, setValidated] = useState(false);

    const onChangeComment = (e) => {
        setComment(e.currentTarget.value);
    }
    const onChangeCommentReasonCode = (e) => {
        setCommentReasonCodeId(e.currentTarget.value);
    }

    const handleSave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        if (form.checkValidity() === true) {
            onSave(comment, commentReasonCodeId);
            closeDialog();
        }

        setValidated(true);
    }

    return (
        <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialog} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t('CommentDialog.Title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSave} id="commentForm">
                    <Form.Select required value={commentReasonCodeId} size="sm" name="commentReasonCodeId" onChange={onChangeCommentReasonCode} className="mb-3">
                        <option key="0" value="">{t('Application.Controls.DefaultSelect')}</option>
                        {
                            businessUnitDetails?.commentReasonCodes && businessUnitDetails.commentReasonCodes.map((reason, i) => {
                                return <option key={i + 1} value={reason.id}>{reason.display}</option>
                            })
                        }
                    </Form.Select>
                    <Form.Control as="textarea" required rows="6" value={comment} onChange={onChangeComment} />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeDialog}>
                    {t('Application.Controls.Close')}
                </Button>
                <Button variant="primary" type="submit" form="commentForm">
                    {t('Application.Controls.Save')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddCommentDialog;